import type { ReactNode } from 'react'
import { KtomEndorsement } from '@/components/KtomEndorsement'

/**
 * Brand frame for the signed-out screens (sign in, forgot password, set
 * password): a Deep Green panel carrying the logo (on a beige tile) and the Ngāti Paoa
 * Moana border, with the form on beige beside it. On a phone the panel sits on
 * top and the border runs across under it instead of down its edge.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh lg:grid lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
      <aside className="on-dark relative bg-pounamu px-6 pb-6 pt-8 text-white lg:flex lg:flex-col lg:justify-center lg:py-16 lg:pl-14 lg:pr-24">
        {/* The logo artwork is transparent outside its blob, so parts of the
            lettering vanish on Deep Green. The brand guide always sets it on
            a beige card; do the same. */}
        <div className="w-fit rounded-3xl bg-paper p-4 lg:p-6">
          <img src="/aunty-logo.png" alt="Kōrero Pūtea with Aunty Āwhi" className="h-24 w-auto lg:h-44" />
        </div>
        <p className="ref mt-6 text-teal">Ki Tua o Matariki · Partner portal</p>
        <p className="mt-2 max-w-sm text-sm text-white/85 lg:text-base">
          The partner portal holds your programme resources, training and evaluation data.
        </p>
        <div className="mt-8 lg:mt-12">
          <KtomEndorsement onDark />
        </div>
        <div aria-hidden="true" className="moana-v absolute inset-y-0 right-6 hidden w-12 text-teal lg:block" />
      </aside>

      <div aria-hidden="true" className="bg-pounamu lg:hidden">
        <div className="moana-h h-6 text-teal" />
      </div>

      <div className="mx-auto flex max-w-md flex-col justify-center px-4 py-10 lg:min-h-dvh">
        {children}
      </div>
    </div>
  )
}
